// src/pages/ForgotPassword.js

import React, { useState } from 'react'
import { useAuth } from '../contexts/AuthContext'
import { Link } from 'react-router-dom'
import { 
  Container, 
  TextField, 
  Button, 
  Typography, 
  Box, 
  Alert 
} from '@mui/material'

// Çoklu dil desteği
import { useTranslation } from 'react-i18next'

export default function ForgotPassword() {
  const { t } = useTranslation()  // i18n Hook

  const [email, setEmail] = useState('')
  const [error, setError] = useState('')
  const [message, setMessage] = useState('')
  const { resetPassword } = useAuth()

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      setMessage('')
      setError('')
      await resetPassword(email)
      setMessage(t('forgotPasswordPage.successReset')) // "Daha fazla talimat için emailinizi kontrol edin."
    } catch (err) {
      setError(t('forgotPasswordPage.errorReset')) // "Şifre sıfırlanamadı"
    }
  }

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 4 }}>
        <Typography variant="h5" mb={2}>
          {t('forgotPasswordPage.title')}
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        {message && (
          <Alert severity="success" sx={{ mb: 2 }}>
            {message}
          </Alert>
        )}

        <form onSubmit={handleSubmit}>
          <TextField
            type="email"
            label={t('forgotPasswordPage.emailLabel')}
            variant="outlined"
            fullWidth
            sx={{ mb: 2 }}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Button type="submit" variant="contained" fullWidth sx={{ mb: 2 }}>
            {t('forgotPasswordPage.resetButton')}
          </Button>
        </form>

        <Typography variant="body2" sx={{ mt: 2 }}>
          <Link to="/login" style={{ textDecoration: 'none' }}>
            {t('forgotPasswordPage.loginLink')}
          </Link>
        </Typography>
      </Box>
    </Container>
  )
}